import { Link } from "react-router-dom";
import "./setting.css";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";

export default function ChangePasswordCommercial() {
  const handleGoBack = () => window.history.back();

  return (
    <>
      <NewSidebareCommercial />
      <div className="setting-page-wrapper">
        <div className="setting-page-inner">
          {/* Back */}
          <button className="setting-back-btn" onClick={handleGoBack}>
            <i className="bi bi-arrow-left"></i> Retour
          </button>

          {/* Form Card */}
          <div className="setting-form-card">
            <h2 className="setting-form-title">
              <i className="bi bi-shield-lock"></i>
              Changer le mot de passe
            </h2>
            <p className="setting-form-subtitle">
              Veuillez saisir vos informations pour mettre à jour votre mot de passe
            </p>

            <div className="setting-form-group">
              <label className="setting-form-label">Ancien mot de passe</label>
              <input
                type="password"
                className="setting-form-input"
                placeholder="Entrez votre mot de passe actuel"
              />
            </div>

            <div className="setting-form-group">
              <label className="setting-form-label">Nouveau mot de passe</label>
              <input
                type="password"
                className="setting-form-input"
                placeholder="Entrez le nouveau mot de passe"
              />
            </div>

            <div className="setting-form-group">
              <label className="setting-form-label">Confirmer le mot de passe</label>
              <input
                type="password"
                className="setting-form-input"
                placeholder="Confirmez le nouveau mot de passe"
              />
            </div>

            <Link to="" className="setting-form-submit">
              <i className="bi bi-check2-circle"></i> Changer le mot de passe
            </Link>

            <Link to="" className="setting-form-alt-link">
              Choisir une autre méthode
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}